import { Vue, Component, Prop } from 'vue-property-decorator';
import GoogleMaterialIcon from '@/components/icons/google-material-icon/google-material-icon';
import { LEARNING_MAP_CONTENT_SEQUENCE } from '@/utils/constants';
import * as d3 from 'd3';

@Component({
    name: 'learning-map-table',
    components: {
        'material-icon': GoogleMaterialIcon,
    },
})

export default class LearningMapTable extends Vue {

    /**
     * @property {Array}
     * Property to store sequence of content items to show
     */
    private contentSequence = LEARNING_MAP_CONTENT_SEQUENCE;

    private isShowMicroCompetency: boolean = false;


    @Prop()
    private tableBody: any;

    @Prop()
    private selectedItems!: string;

    private selectedPrerequisites: any = {};

    // -------------------------------------------------------------------------------
    // Actions
    private onScrollTop() {
        this.$emit('onScrollTop');
    }


    private onToggleMicroCompetency() {
        this.isShowMicroCompetency = !this.isShowMicroCompetency;
        d3.selectAll('.micro-competency').classed('hide-row', this.isShowMicroCompetency);
    }

    private onSelectContentType(contentId: string, contentType: string, content: any) {
        this.$emit('onSelectContentType', {
            contentId,
            contentType,
        });
    }

    private onPreview(tableRow: any) {
        this.selectedPrerequisites = tableRow;
        this.$bvModal.show('prerequisites-preview');
    }

    private hideModal() {
        this.selectedPrerequisites = {};
        this.$bvModal.hide('prerequisites-preview');
    }

}
